export default {"src":"/_next/static/media/robot-smile.ddf51f87.svg","height":37,"width":45};